import { render, staticRenderFns } from "./InputPeriodForm.vue?vue&type=template&id=54a515de"
import script from "./InputPeriodForm.vue?vue&type=script&lang=js"
export * from "./InputPeriodForm.vue?vue&type=script&lang=js"
import style0 from "./InputPeriodForm.vue?vue&type=style&index=0&id=54a515de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports